export const COLOR_NIGHT_0 = '#FFFFFF';
export const COLOR_NIGHT_100 = '#EDEDEF';
export const COLOR_NIGHT_200 = '#D4D4D8';
export const COLOR_NIGHT_300 = '#BCBBC2';
export const COLOR_NIGHT_400 = '#A4A3AC';
export const COLOR_NIGHT_500 = '#8B8A94';
export const COLOR_NIGHT_600 = '#72717D';
export const COLOR_NIGHT_700 = '#5E5D6B';
export const COLOR_NIGHT_800 = '#4A4959';
export const COLOR_NIGHT_900 = '#242435';

export const COLOR_NIGHT_0_32P = 'rgba(255, 255, 255, 0.32)';
export const COLOR_NIGHT_0_64P = 'rgba(255, 255, 255, 0.64)';

export const COLOR_NIGHT_100_64P = 'rgba(237, 237, 239, 0.64)';

export const COLOR_NIGHT_200_64P = 'rgba(212, 212, 216, 0.32)';

export const COLOR_NIGHT_500_8P = 'rgba(94, 93, 107, 0.08)';
export const COLOR_NIGHT_500_16P = 'rgba(94, 93, 107, 0.16)';
export const COLOR_NIGHT_500_24P = 'rgba(94, 93, 107, 0.24)';
export const COLOR_NIGHT_500_32P = 'rgba(94, 93, 107, 0.32)';
export const COLOR_NIGHT_500_40P = 'rgba(94, 93, 107, 0.40)';
export const COLOR_NIGHT_500_48P = 'rgba(94, 93, 107, 0.48)';

export const COLOR_NIGHT_900_8P = 'rgba(36, 36, 53, 0.08)';
export const COLOR_NIGHT_900_10P = 'rgba(36, 36, 53, 0.1)';
export const COLOR_NIGHT_900_16P = 'rgba(36, 36, 53, 0.16)';
export const COLOR_NIGHT_900_64P = 'rgba(36, 36, 53, 0.64)';

export const COLOR_NIGHT_1000_32P = 'rgba(0, 0, 0, 0.32)';
export const COLOR_NIGHT_1000_64P = 'rgba(0, 0, 0, 0.64)';

export const COLOR_GREY_0 = '#FFFFFF';
export const COLOR_GREY_100 = '#EBEBED';
export const COLOR_GREY_200 = '#CCCBD1';
export const COLOR_GREY_300 = '#ACAAB3';
export const COLOR_GREY_400 = '#787583';
export const COLOR_GREY_500 = '#585565';
export const COLOR_GREY_600 = '#4C495A';
export const COLOR_GREY_700 = '#403E4F';
export const COLOR_GREY_800 = '#2E2C3F';
export const COLOR_GREY_900 = '#1E1C2B';
export const COLOR_GREY_1000 = '#181621';
export const COLOR_GREY_1100 = '#08070C';

export const COLOR_GREY_0_32P = 'rgba(255, 255, 255, 0.32)';
export const COLOR_GREY_0_64P = 'rgba(255, 255, 255, 0.64)';

export const COLOR_GREY_500_8P = 'rgba(24, 22, 33, 0.08)';
export const COLOR_GREY_500_16P = 'rgba(24, 22, 33, 0.16)';
export const COLOR_GREY_500_24P = 'rgba(24, 22, 33, 0.24)';
export const COLOR_GREY_500_32P = 'rgba(24, 22, 33, 0.32)';
export const COLOR_GREY_500_40P = 'rgba(24, 22, 33, 0.40)';
export const COLOR_GREY_500_48P = 'rgba(24, 22, 33, 0.48)';

export const COLOR_GREY_1000_32P = 'rgba(8, 7, 12, 0.32)';
export const COLOR_GREY_1000_64P = 'rgba(8, 7, 12, 0.64)';

export const COLOR_INDIGO_100 = '#EFEFFF';
export const COLOR_INDIGO_200 = '#B3B2FB';
export const COLOR_INDIGO_300 = '#8B89F3';
export const COLOR_INDIGO_400 = '#6C69E8';
export const COLOR_INDIGO_500 = '#3E3BD9';
export const COLOR_INDIGO_600 = '#2D2BBA';
export const COLOR_INDIGO_700 = '#1F1D9C';
export const COLOR_INDIGO_800 = '#14127D';
export const COLOR_INDIGO_900 = '#0C0B68';

export const COLOR_INDIGO_300_32P = 'rgba(139, 137, 243, 0.32)';

export const COLOR_INDIGO_500_8P = 'rgba(62, 59, 217, 0.08)';
export const COLOR_INDIGO_500_16P = 'rgba(62, 59, 217, 0.16)';
export const COLOR_INDIGO_500_24P = 'rgba(62, 59, 217, 0.24)';
export const COLOR_INDIGO_500_32P = 'rgba(62, 59, 217, 0.32)';
export const COLOR_INDIGO_500_40P = 'rgba(62, 59, 217, 0.40)';
export const COLOR_INDIGO_500_48P = 'rgba(62, 59, 217, 0.48)';

export const COLOR_BLUE_100 = '#D6E2FC';
export const COLOR_BLUE_200 = '#D6E2FC';
export const COLOR_BLUE_300 = '#A2BEE8';
export const COLOR_BLUE_400 = '#80A6DF';
export const COLOR_BLUE_500 = '#5A8CD6';
export const COLOR_BLUE_600 = '#2365C8';
export const COLOR_BLUE_700 = '#205CB6';
export const COLOR_BLUE_800 = '#194990';
export const COLOR_BLUE_900 = '#143A72';

export const COLOR_BLUE_500_8P = 'rgba(35, 101, 200, 0.08)';
export const COLOR_BLUE_500_16P = 'rgba(35, 101, 200, 0.16)';
export const COLOR_BLUE_500_24P = 'rgba(35, 101, 200, 0.24)';
export const COLOR_BLUE_500_32P = 'rgba(35, 101, 200, 0.32)';
export const COLOR_BLUE_500_40P = 'rgba(35, 101, 200, 0.40)';
export const COLOR_BLUE_500_48P = 'rgba(35, 101, 200, 0.48)';

export const COLOR_GREEN_100 = '#EFFDE3';
export const COLOR_GREEN_200 = '#DDFBC9';
export const COLOR_GREEN_300 = '#C2F4AB';
export const COLOR_GREEN_400 = '#A8EA92';
export const COLOR_GREEN_500 = '#81DD6E';
export const COLOR_GREEN_600 = '#5BBE51';
export const COLOR_GREEN_700 = '#39A037';
export const COLOR_GREEN_800 = '#237F28';
export const COLOR_GREEN_900 = '#166A1F';

export const COLOR_GREEN_500_8P = 'rgba(35, 127, 40, 0.08)';
export const COLOR_GREEN_500_16P = 'rgba(35, 127, 40, 0.16)';
export const COLOR_GREEN_500_24P = 'rgba(35, 127, 40, 0.24)';
export const COLOR_GREEN_500_32P = 'rgba(35, 127, 40, 0.32)';
export const COLOR_GREEN_500_40P = 'rgba(35, 127, 40, 0.40)';
export const COLOR_GREEN_500_48P = 'rgba(35, 127, 40, 0.48)';

export const COLOR_YELLOW_100 = '#FFFAE1';
export const COLOR_YELLOW_200 = '#FFEFB3';
export const COLOR_YELLOW_300 = '#FFE48D';
export const COLOR_YELLOW_400 = '#FFD871';
export const COLOR_YELLOW_500 = '#FFC641';
export const COLOR_YELLOW_600 = '#DBA22F';
export const COLOR_YELLOW_700 = '#B78121';
export const COLOR_YELLOW_800 = '#926115';
export const COLOR_YELLOW_900 = '#7B4B0D';

export const COLOR_YELLOW_500_8P = 'rgba(255, 198, 65, 0.08)';
export const COLOR_YELLOW_500_16P = 'rgba(255, 198, 65, 0.16)';
export const COLOR_YELLOW_500_24P = 'rgba(255, 198, 65, 0.24)';
export const COLOR_YELLOW_500_32P = 'rgba(255, 198, 65, 0.32)';
export const COLOR_YELLOW_500_40P = 'rgba(255, 198, 65, 0.40)';
export const COLOR_YELLOW_500_48P = 'rgba(255, 198, 65, 0.48)';

export const COLOR_RED_100 = '#FEDDD8';
export const COLOR_RED_200 = '#FFBBB2';
export const COLOR_RED_300 = '#FD9789';
export const COLOR_RED_400 = '#FC736A';
export const COLOR_RED_500 = '#ED4646';
export const COLOR_RED_600 = '#D62F29';
export const COLOR_RED_700 = '#B31C23';
export const COLOR_RED_800 = '#901122';
export const COLOR_RED_900 = '#770A21';

export const COLOR_RED_500_8P = 'rgba(237, 70, 70, 0.08)';
export const COLOR_RED_500_16P = 'rgba(237, 70, 70, 0.16)';
export const COLOR_RED_500_24P = 'rgba(237, 70, 70, 0.24)';
export const COLOR_RED_500_32P = 'rgba(237, 70, 70, 0.32)';
export const COLOR_RED_500_40P = 'rgba(237, 70, 70, 0.40)';
export const COLOR_RED_500_48P = 'rgba(237, 70, 70, 0.48)';

export const COLOR_RED_600_16P = 'rgba(214, 47, 41, 0.16)';
